import React from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {Button, DialogActions, IconButton, Slide, Stack} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteDialog(props) {
    const {onClose, open, handleRemove} = props;

    const handleClose = () => {
        onClose();
    };

    const remove = () => {
        handleRemove()
        handleClose()
    }

    return (
        <Dialog onClose={handleClose} open={open} TransitionComponent={Transition}>
            <DialogTitle>Are you sure?</DialogTitle>
            <Button onClick={handleClose}>
                No
            </Button>
            <Button onClick={remove}>
                Yes
            </Button>
        </Dialog>
    );
}

DeleteDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function RemoveQueueElementButton({id, handleRemoveElement}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function handleRemove() {
        handleClose()
        handleRemoveElement(id)
    }

    return (
        <div>
            <IconButton onClick={handleClickOpen} aria-label='delete' size={"large"}>
                <RemoveCircleOutlineIcon/>
            </IconButton>
            <DeleteDialog
                handleRemove={handleRemove}
                open={open}
                onClose={handleClose}
            />
        </div>
    )
}